import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { Column } from '../../Common.styles'
import SpecificationsSection from './SpecificationsSection'
import Overview from './Overview'
import { isFeaturesOrBenefits } from '../helpers'

const OverviewTab = ({ features = [], benefits = [], ...props }) =>
  <Wrapper>
    {
      Boolean(isFeaturesOrBenefits(features, benefits)) &&
        <Column responsive padding_desktop="0 10px 0 0" padding_mobile="0 0 25px 0">
          <Overview
            features={ features }
            benefits={ benefits }
            { ...props } />
        </Column>
    }
    <SpecificationColumnWrapper
      responsive={ isFeaturesOrBenefits(features, benefits) }
      isFeaturesOrBenefits={ isFeaturesOrBenefits(features, benefits) }
      padding_desktop={ isFeaturesOrBenefits(features, benefits) && '0 50px 0 10px' }
      padding_mobile={ isFeaturesOrBenefits(features, benefits) && '35px 0 0 0' } >
      <SpecificationsSection { ...props } />
    </SpecificationColumnWrapper>
  </Wrapper>

export default OverviewTab

OverviewTab.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.string),
  features: PropTypes.arrayOf(PropTypes.string)
}

const Wrapper = styled.div`
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBook(14, 400)}
  ${Mixin.responsive('padding', '40px 0 110px', '31px 16px 90px')}
`

const SpecificationColumnWrapper = styled(Column)`
  ${Media.mobile`
    border-top: 1px solid ${Theme.colors.light_grey};
  `}
`
